import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import InductionContext from '../../context/Induction/InductionContext';
import { CustomAlert } from '../CustomAlert/CustomAlert';
import { CustomPlayer } from '../CustomPlayer/CustomPlayer';
import { CustomPDFViewer } from '../CustomPDFViewer/CustomPDFViewer';
import { isIntegrated } from '../../helpers/helpers';
import { DownloadInduction } from '../DownloadInduction/DownloadInduction';
export const InductionPreviewModal = ({ setModal, modal, induction }) => {

    const { t } = useTranslation();

    const { id } = useParams();

    const { previewInduction, previewInductionDeleteURL, inductionState } = useContext(InductionContext);

    const { url, error } = inductionState;

    const [currentFileIndex, setCurrentFileIndex] = useState(0);
    const [fileUrlKey, setFileUrlKey] = useState(0);

    const currentFile = induction.files[currentFileIndex];

    const handleClose = () => {
        setModal(!modal)
        previewInductionDeleteURL(currentFile.name, id)
    }

    // Llamar a previewInduction cuando cambia el archivo o cuando se monta el componente
    useEffect(() => {
        if (currentFile && currentFile.name && modal) {
            // Incrementar la key para forzar el remontaje del PDF cuando cambia el archivo
            setFileUrlKey(prev => prev + 1);
            previewInduction(currentFile.name, id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentFileIndex, currentFile, id, modal])

    // Llamar a previewInduction cuando el modal se abre por primera vez
    useEffect(() => {
        if (currentFile && currentFile.name && modal) {
            previewInduction(currentFile.name, id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modal])

    return (
        <Modal isOpen={modal} toggle={handleClose} size={'xl'}>
            <ModalHeader>
                {induction.name}
            </ModalHeader>
            <ModalBody
                style={{
                    maxHeight: '80vh',
                    overflowY: 'auto',
                    padding: '1rem'
                }}
            >
                <div className='d-flex flex-column align-items-center'>
                    {/* Navegación entre archivos si hay múltiples */}
                    {induction.files.length > 1 && (
                        <div className="d-flex justify-content-center gap-3 mb-3 w-100">
                            <button
                                className="btn btn-outline-primary"
                                disabled={currentFileIndex === 0}
                                onClick={() => setCurrentFileIndex(currentFileIndex - 1)}
                            >
                                <i className="fa-solid fa-chevron-left"></i> {t('common.previous')}
                            </button>
                            <span className="align-self-center">
                                {currentFileIndex + 1} / {induction.files.length}
                            </span>
                            <button
                                className="btn btn-outline-primary"
                                disabled={currentFileIndex === induction.files.length - 1}
                                onClick={() => setCurrentFileIndex(currentFileIndex + 1)}
                            >
                                {t('common.next')} <i className="fa-solid fa-chevron-right"></i>
                            </button>
                        </div>
                    )}

                    {
                        url ?
                            <>
                                {
                                    currentFile.type.split('/')[0] === 'video' ?
                                        <div style={{ height: '60vh' }}>
                                            <CustomPlayer url={url} />
                                        </div>
                                        :
                                        currentFile.type === 'application/pdf' ?
                                            <div style={{ height: '65vh', width: '100%' }}>
                                                <CustomPDFViewer
                                                    key={`${currentFileIndex}-${fileUrlKey}-${url}`}
                                                    fileUrl={url}
                                                />
                                            </div>
                                            :
                                            <img className='w-100' src={url} alt={''} />
                                }
                                {
                                    induction.allow_download === true && isIntegrated() ?
                                        <DownloadInduction inductionName={currentFile.name} />
                                        :
                                        null
                                }
                            </>
                            :
                            !error ?
                                <Spinner className='mx-auto d-flex' />
                                :
                                null
                    }
                    {error ? <CustomAlert text={t('common.error_server')} color={'danger'} /> : null}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button onClick={handleClose}>{t('common.close')}</Button>
            </ModalFooter>
        </Modal>
    )
}
